/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GuideVersionResource } from "./GuideVersionResource";
export const GuideVersionResponse = core.serialization.object({
    data: GuideVersionResource,
});
